import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import { MediaProvider } from "@/context/MediaContext";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import DriverProgram from "@/pages/DriverProgram";
import Investors from "@/pages/Investors";
import Dashboard from "@/pages/Dashboard";
import Careers from "@/pages/Careers";
import { BlogList, BlogPost } from "@/pages/Blog";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminPanel from "@/pages/admin/AdminPanel";

const Public = ({ children }) => <PublicLayout>{children}</PublicLayout>;

function App() {
  return (
    <AuthProvider>
      <MediaProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<Public><Home /></Public>} />
          <Route path="/drivers" element={<Public><DriverProgram /></Public>} />
          <Route path="/investors" element={<Public><Investors /></Public>} />
          <Route path="/dashboard" element={<Public><Dashboard /></Public>} />
          <Route path="/careers" element={<Public><Careers /></Public>} />
          <Route path="/blog" element={<Public><BlogList /></Public>} />
          <Route path="/blog/:slug" element={<Public><BlogPost /></Public>} />
          <Route path="/contact" element={<Public><Contact /></Public>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="*" element={<Public><Home /></Public>} />
        </Routes>
      </BrowserRouter>
      </MediaProvider>
    </AuthProvider>
  );
}

export default App;
